// import React, { Component } from "react";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import { USERGET_DATA} from "../service/apiUrl";
import { useSelector } from "react-redux";
import { postApiCall } from "../service/PostApiCall";
import { INVENTORY_CREATED } from "../service/apiUrl";
import { useNavigate } from "react-router-dom";
import { STRING } from "../constants/string";
import Utils from "../utility/utility";
import LoadingButton from "../components/LoadingButton";

/* Error slot: always holds its line, so showing a message never shifts
   the form. */
const FieldError = ({ msg }) => (
  <span className={"field-error" + (msg ? " is-shown" : "")}>{msg || ""}</span>
);

const AddInventory = (props) => {
  const [name , setName] = useState();
  const [serialno , setSerialNo] = useState();
  const [brand , setBrand] = useState();
  const [type , setType] = useState();
  const [assign , setAssign] = useState();
  const [errors, setErrors] = useState({});

  // each field clears its own error as soon as it has a value
  useEffect(() => {
    setErrors((prev) => {
      if (!Object.keys(prev).length) return prev;
      const next = { ...prev };
      if (next.name && !Utils.isEmpty(name)) delete next.name;
      if (next.serialno && !Utils.isEmpty(serialno)) delete next.serialno;
      if (next.brand && !Utils.isEmpty(brand)) delete next.brand;
      if (next.type && !Utils.isEmpty(type)) delete next.type;
      if (next.assign && !Utils.isEmpty(assign)) delete next.assign;
      return Object.keys(next).length === Object.keys(prev).length ? prev : next;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [name, serialno, brand, type, assign]);

  const navigate = useNavigate();
  const validateannouncement = () => {
    // every check runs, so all missing fields show at once
    const e = {};
    if (Utils.isEmpty(name)) e.name = STRING.NAME;
    if (Utils.isEmpty(serialno)) e.serialno = STRING.SERIALNO;
    if (Utils.isEmpty(brand)) e.brand = STRING.BRAND;
    if (Utils.isEmpty(type)) e.type = STRING.TYPE;
    if (Utils.isEmpty(assign)) e.assign = STRING.ASSIGN;
    setErrors(e);
    const message = Object.keys(e).length ? "invalid" : "";
    return message;
  };
  const createInventort = ()=>{
    const message = validateannouncement();
    if (message) {
      return false;
    } else{
    const data = {
      name : name,
      brand : brand,
      type : type,
      serial_number : serialno,
      assign_to : assign,

    }
    return postApiCall(data, signdata?.data?.access_token,  INVENTORY_CREATED)
    .then((result) => {
      navigate("/inventory-listing");
      Utils.toast("success", STRING.INVENTORY_SUCCESSFUL);
    })
    .catch((error) => {
      console.error("USER_HELPER", error);
      throw error;
    });
  }
  }
const signdata = useSelector((state) => state.signinReducers);
const [typeOption , setOption] = useState([]);
const [helperData, setHelperData] = useState([]);
useEffect(()=>{
  const type = [
    {value : 'keyboard',label : 'Keyboard'},
    {value : "mouse",label : "Mouse"},
    {value : "destop",label : "Destop"},
    {value : "cpu",label : "CPU"},
    {value : "UPS",label : "UPS"},
    {value : "laptop",label : "Laptop"},
    {value : "datacable",label : "Datacable"},
    {value : "ctype datacable",label : "Ctype Datacable"},
    {value : "mobile",label : "Mobile"},
    {value : "multiport",label : "Multiport"},
   ]
   setOption(type)
},[])
useEffect(() => {
  postApiCall([], signdata?.data?.access_token, USERGET_DATA)
    .then((result) => {
      setHelperData(result?.all_users);
    })
    .catch((error) => {
      console.error("USER_HELPER", error);
    });
}, []);
  return (
    <>
      <div className={props?.data?.transtion == true ? "contents" : "content"}>
        <div className="content-top-spacer"></div>
        <div className="color-body">
          <div className="page-head">
            <div className="page-eyebrow">Workplace</div>
            <h1 className="page-title">Add Inventory</h1>
          </div>
          <div className="col-md-6 manage">
            <div className="card-input mt-5 mb-2">
              <div className="col-md-12">
                <div className="mt-3">
                  <h5 className="border-bottom pb-2">Create Inventory</h5>
                </div>
                <form>
                  <div className="row mt-3">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="exampleInputEmail1">Name</label>
                        <input
                          type="text"
                          className={"form-control" + (errors.name ? " is-invalid" : "")}
                          onChange={(data)=>{
                            setName(data.target.value)
                          }}

                          // placeholder="Enter Project Owner"
                        />
                        <FieldError msg={errors.name} />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="exampleInputEmail1">
                          Serial Number
                        </label>
                        <input
                          type="text"
                          className={"form-control" + (errors.serialno ? " is-invalid" : "")}
                          onChange={(data)=>{
                            setSerialNo(data.target.value)
                          }}

                          // placeholder="Enter Project Owner"
                        />
                        <FieldError msg={errors.serialno} />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="exampleInputEmail1">Brand</label>
                        <input
                          type="text"
                          className={"form-control" + (errors.brand ? " is-invalid" : "")}
                          onChange={(data)=>{
                            setBrand(data.target.value)
                          }}

                          // placeholder="Enter Project Owner"
                        />
                        <FieldError msg={errors.brand} />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="exampleInputEmail1">Type</label>
                        <Select classNamePrefix="rs" menuPortalTarget={document.body} menuPosition="fixed" options={typeOption} onChange={(data)=> setType(data.value)}/>
                        <FieldError msg={errors.type} />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="exampleInputEmail1">Assign To</label>
                        <Select classNamePrefix="rs" menuPortalTarget={document.body} menuPosition="fixed" options={helperData} onChange={(data)=>{
                          setAssign(data.value)
                        }}/>
                        <FieldError msg={errors.assign} />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="row mb-5 mt-4 ml-2">
                        <div className="">
                          <LoadingButton className="create-button" successLabel="Created" onAction={createInventort}>
                            Create
                          </LoadingButton>
                        </div>
                        <div className="ml-2">
                          <button
                            type="button"
                            className="create-button1 btn-info"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12"></div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddInventory;
